function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.232 40.754l14.091-6.56L42 23l-28.666 8.998a8 8 0 001.09 15.727"
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(68.884)",
  x: 35.586,
  y: -32.894,
  width: 14,
  height: 2,
  rx: 1,
  ry: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 44.5a9.5 9.5 0 01-9.5 9.5 9.5 9.5 0 01-9.5-9.5 9.5 9.5 0 019.5-9.5 9.5 9.5 0 019.5 9.5z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 35v19M33 44.5H14M30.218 37.782L16.783 51.217M16.782 37.782l13.435 13.435M10 46l-3 8H4l4.3-10.3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46 49.5a4.5 4.5 0 01-4.5 4.5 4.5 4.5 0 01-4.5-4.5 4.5 4.5 0 014.5-4.5 4.5 4.5 0 014.5 4.5z",
  strokeLinecap: "square",
  strokeWidth: 1.002
}));

var SvgCannon = function SvgCannon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCannon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cannon.c41f6ef0.svg";
export { ForwardRef as ReactComponent };